module.exports = __webpack_public_path__ + "img/Alshad-Ahmad.2bce570d.png";